import { useState } from "react";
import { Link, useLocation } from "wouter";

interface MobileNavbarProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileNavbar = ({ isOpen, onClose }: MobileNavbarProps) => {
  const [servicesOpen, setServicesOpen] = useState(false);
  const [location] = useLocation();

  const toggleServices = () => {
    setServicesOpen(!servicesOpen);
  };

  if (!isOpen) return null;

  const handleNavigation = () => {
    onClose();
    setServicesOpen(false);
  };

  return (
    <div className="md:hidden bg-white border-t">
      <div className="px-2 pt-2 pb-3 space-y-1">
        <Link 
          href="/" 
          onClick={handleNavigation}
          className={`block px-3 py-2 rounded-md font-medium ${location === '/' ? 'text-primary' : 'hover:bg-neutral hover:text-primary'}`}
        >
          Home
        </Link>
        <div className="relative">
          <button 
            onClick={toggleServices}
            className="w-full flex justify-between px-3 py-2 rounded-md font-medium hover:bg-neutral hover:text-primary"
          >
            Services
            <svg 
              className={`w-4 h-4 mt-1 transform transition-transform ${servicesOpen ? 'rotate-180' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div className={`${servicesOpen ? 'block' : 'hidden'} px-4 py-2 space-y-1`}>
            <Link 
              href="/services/phone-repair" 
              onClick={handleNavigation}
              className="block px-3 py-2 text-sm hover:bg-neutral hover:text-primary"
            >
              Phone Repair
            </Link>
            <Link 
              href="/services/computer-repair" 
              onClick={handleNavigation}
              className="block px-3 py-2 text-sm hover:bg-neutral hover:text-primary"
            >
              Computer Repair
            </Link>
            <Link 
              href="/services/tablet-repair" 
              onClick={handleNavigation}
              className="block px-3 py-2 text-sm hover:bg-neutral hover:text-primary"
            >
              Tablet Repair
            </Link>
            <Link 
              href="/services/game-console-repair" 
              onClick={handleNavigation}
              className="block px-3 py-2 text-sm hover:bg-neutral hover:text-primary"
            >
              Game Console Repair
            </Link>
          </div>
        </div>
        <Link 
          href="/pricing" 
          onClick={handleNavigation}
          className={`block px-3 py-2 rounded-md font-medium ${location === '/services' ? 'text-primary' : 'hover:bg-neutral hover:text-primary'}`}
        >
          Pricing
        </Link>
        <Link 
          href="/telecom" 
          onClick={handleNavigation}
          className={`block px-3 py-2 rounded-md font-medium ${location === '/telecom' ? 'text-primary' : 'hover:bg-neutral hover:text-primary'}`}
        >
          Telecom
        </Link>
        <Link 
          href="/contact" 
          onClick={handleNavigation}
          className={`block px-3 py-2 rounded-md font-medium ${location === '/contact' ? 'text-primary' : 'hover:bg-neutral hover:text-primary'}`}
        >
          Contact
        </Link>
        <Link 
          href="/booking" 
          onClick={handleNavigation}
          className="block px-3 py-2 rounded-md text-white bg-[#FF6633] font-medium text-center"
        >
          Book Now
        </Link>
      </div>
    </div>
  );
};

export default MobileNavbar;
